import {
    CLEAR_CONFIG_SHIFT,
    FETCH_CONFIG_SHIFTS,
    LIST_CONFIG_SHIFTS
} from "./types";

const init = {
    isLoading: false,
    filter: {},
    rows: []
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_CONFIG_SHIFTS:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_CONFIG_SHIFTS:
            return {
                ...state,
                isLoading: false,
                rows: payload
            };
        case CLEAR_CONFIG_SHIFT:
            return {
                ...init
            };
        default:
            return state;
    }
}
